import { Canvas } from '@react-three/fiber'
import { TalkingHeadScene } from './TalkingHeadScene'
import styles from "./TalkingHead.module.scss"
import { useIsMobile } from '../../hooks/useIsMobile';

interface TalkingHeadProps {
  fullScreen?: boolean;
  scale: number;
  onFirstFrame?: () => void;
  keyboardHeight: number;
}

export const TalkingHead = ({ fullScreen, scale, onFirstFrame, keyboardHeight }: TalkingHeadProps) => {

  const isMobile = useIsMobile(900);
  
  return (
    <div className={styles.talkingHeadContainer}>
      <div 
        className={isMobile ? styles.talkingHeadCanvasWrapperMobile : fullScreen ? styles.talkingHeadCanvasWrapperFullSize : styles.talkingHeadCanvasWrapper}
        style={isMobile && keyboardHeight > 0 ? {bottom: `-${keyboardHeight}px`} : {}} 
        >
        <Canvas resize={{ debounce: 0 }}>
          <TalkingHeadScene scale={scale} onFirstFrame={onFirstFrame}/>
        </Canvas>
      </div>
    </div>
  )
}
